import React from 'react';

const ToastContext = /*#__PURE__*/React.createContext({
  showToast: () => '',
  hideToast: () => undefined
});
var ToastContext$1 = ToastContext;

export { ToastContext$1 as default };
//# sourceMappingURL=context.js.map
